import ButtonSignUp from './ButtonSignUp'

export default ButtonSignUp
// eslint-disable-next-line import/export
export * from './ButtonSignUp'
